import { useState } from "react";
import useManufacturerList from "../../../hooks/manufacturer/useManufacturerList";

export default function useManufacturerBody({ searchBy, manuKeyword, manufacturerList }) {
  const [pagi, setPagi] = useState({
    limit: 50,
    skip: 0,
  });
  const {
    data: manufacturers,
    isLoading,
    error,
  } = useManufacturerList({
    limit: pagi?.limit,
    skip: pagi?.skip,
    searchField: !!searchBy ? manufacturerList[searchBy - 1]?.value : manufacturerList[0]?.value,
    searchValue: !!manuKeyword ? manuKeyword : undefined,
    sortField: "name",
    sortOrder: "asc",
  });
  const sortData = ["no", "name", "origin"];
  return {
    total: manufacturers?.count,
    bodyList: Array.isArray(manufacturers?.data) ? manufacturers?.data?.map((v, index) => ({ ...v, no: index + 1 })) : [],
    sortData,
    isLoading,
    setPagi,
    pagi,
    error,
    total: manufacturers?.count ?? 0,
  };
}
